import Header from "../components/Header";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import About from "../components/About";
import Services from "../components/Services";
import Gallery from "../components/Gallery";
import QuoteEstimator from "../components/QuoteEstimator";
import Testimonials from "../components/Testimonials";
import ServiceAreas from "../components/ServiceAreas";
import Journal from "../components/Journal";
import BookingForm from "../components/BookingForm";
import Footer from "../components/Footer";
import ChatWidget from "../components/ChatWidget";
import FloatingActions from "../components/FloatingActions";
import Seo from "../components/Seo";

export default function Home() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Painter",
        "@id": "https://themelbournepainters.com.au/#business",
        "name": "The Melbourne Painters",
        "url": "https://themelbournepainters.com.au/",
        "telephone": "+61426677479",
        "email": "Gurdeep@themelbournepainters.com.au",
        "priceRange": "$$",
        "address": { "@type": "PostalAddress", "addressLocality": "Melbourne", "addressRegion": "VIC", "addressCountry": "AU" },
        "areaServed": ["Melbourne", "Bayside Melbourne", "South East Melbourne", "Mornington Peninsula"],
        "aggregateRating": { "@type": "AggregateRating", "ratingValue": "4.9", "reviewCount": "80", "bestRating": "5" },
      },
      {
        "@type": "WebSite",
        "@id": "https://themelbournepainters.com.au/#website",
        "url": "https://themelbournepainters.com.au/",
        "name": "The Melbourne Painters",
        "publisher": { "@id": "https://themelbournepainters.com.au/#business" },
        "inLanguage": "en-AU",
      },
      {
        "@type": "FAQPage",
        "mainEntity": [
          { "@type": "Question", "name": "How much does it cost to paint a 3-bedroom house in Melbourne?",
            "acceptedAnswer": { "@type": "Answer", "text": "A full interior repaint of a 3-bedroom single-storey house in Melbourne typically ranges from $5,500 to $11,000 in 2026, depending on ceiling inclusion, prep level and paint choice. Use our AI Estimator for an instant ballpark." } },
          { "@type": "Question", "name": "Do you provide free quotes?",
            "acceptedAnswer": { "@type": "Answer", "text": "Yes — every quote is free, on-site, and fixed-price. We respond within 24 hours of your enquiry." } },
          { "@type": "Question", "name": "Which Melbourne suburbs do you service?",
            "acceptedAnswer": { "@type": "Answer", "text": "We cover 94+ suburbs across Inner South-East, Bayside, South East Melbourne and the entire Mornington Peninsula, including Brighton, Toorak, Mornington, Sorrento, Glen Waverley and Frankston." } },
          { "@type": "Question", "name": "Are you insured and accredited?",
            "acceptedAnswer": { "@type": "Answer", "text": "Yes — fully public-liability insured and accredited applicators of Dulux, Wattyl and Taubmans premium paint systems." } },
        ],
      },
    ],
  };

  return (
    <div className="min-h-screen bg-[#F2F2EF] text-[#111]">
      <Seo
        title="Melbourne Painters | Premium Interior & Exterior House Painting | The Melbourne Painters"
        description="Melbourne's premium painters — 94+ suburbs across Bayside, South-East & Mornington Peninsula. Free 24-hr quotes · Dulux-accredited · Fully insured · Fixed-price."
        keywords="Melbourne painters, painters Melbourne, house painters Melbourne, interior painting, exterior painting, commercial painters, residential painters, Bayside painters, Mornington Peninsula painters"
        path="/"
        jsonLd={jsonLd}
      />
      <Header />
      <main>
        <h1 className="sr-only">The Melbourne Painters — Premium interior, exterior, residential and commercial painting across Melbourne, Bayside, South-East and the Mornington Peninsula.</h1>
        <Hero />
        <Marquee />
        <About />
        <Services />
        <Gallery />
        <QuoteEstimator />
        <Testimonials />
        <ServiceAreas />
        <Journal />
        <BookingForm />
        <Marquee reverse />
      </main>
      <Footer />
      <ChatWidget />
      <FloatingActions />
    </div>
  );
}
